const $ = jQuery;
const SITE_URL = siteVariables.site_url;
let url = `${SITE_URL}wp-admin/admin-ajax.php`;

document.addEventListener("DOMContentLoaded", (event) => {
	const hasResourcesArchive = document.querySelector(".resources-archive-wrapper");

	if (hasResourcesArchive) {
		const filterBar = hasResourcesArchive.querySelector(".resources-cat-filters-bar");
		const section = hasResourcesArchive.querySelector(".resources-list");
		const container = hasResourcesArchive.querySelector(".resources-list > .inner-wrapper");
		const noPost = hasResourcesArchive.querySelector(".resources-list .no-post");
		const loadingBtnWrapper = hasResourcesArchive.querySelector(".resources-list .load-more-btn-wrapper");
		const resources = hasResourcesArchive.querySelectorAll(".resource-card");
		const footer = document.querySelector(".site-footer");
		let page = 1;
		let postsPerPage = 6;
		let offset;
		let maxPages;
		let catType = "";

		/**
		 * Calculate how many posts should show by default based on view port height
		 */
		const containerRect = container.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		const containerBottomRelativeToPage = containerRect.bottom + window.scrollY;
		const documentHeight = document.documentElement.offsetHeight;
		const distanceFromPageBottom = documentHeight - containerBottomRelativeToPage;
		const distanceFromWindowBottom = windowHeight - containerBottomRelativeToPage;
		const resourceHeight = resources[0].getBoundingClientRect().height + 32;

		// See if cat params is set in url and then get
		const currentURL = new URL(window.location.href);
		catType = currentURL.searchParams.get("type") || "";

		// Infinite Scroll
		let options = {
			// rootMargin: "-130px",
			rootMargin: "0px",
			threshold: 0,
		};
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(async (entry) => {
				console.log(entry);
				if (entry && page === 1) {
					if (distanceFromWindowBottom > 0) {
						if (distanceFromPageBottom > resourceHeight) {
							const extraRows = Math.trunc(distanceFromPageBottom / resourceHeight);
							postsPerPage += extraRows * 3;
						}
					}
					await loadResources();
				} else if (entry.isIntersecting) {
					await loadResources();
				}
			});
		}, options);
		observer.observe(footer);

		// On Button Click
		filterBar.addEventListener("click", async (e) => {
			if (!e.target.getAttribute("data-type")) return;
			page = 1;
			catType = e.target.getAttribute("data-type");
			if (observer) observer.disconnect();
			observer.observe(footer);
		});

		async function loadResources() {
			loadingBtnWrapper.classList.add("show");
			$.ajax({
				type: "POST",
				url: url,
				dataType: "json",
				data: {
					action: "divichild_resources_filters_ajax",
					catType,
					page,
					postsPerPage,
					offset,
				},
				success: function (res) {
					// console.log(page);
					// console.log(res);
					maxPages = res.maxPages;

					if (res.maxPages > 0 && page <= res.maxPages) {
						if (page <= 1) {
							container.innerHTML = res.html;
						} else {
							container.innerHTML += res.html;
						}
					}
					page++;
					if (page > res.maxPages) {
						if (observer) observer.disconnect();
					}

					loadingBtnWrapper.classList.remove("show");
				},
				error: function (xhr, status, error) {
					console.log(error);
				},
			});
		}
	}
});
